/**
 * 前端api网关，在这里做一些骚操作，比如缓存
 */

import np from "nprogress";
import {getCookie} from '@lib/util'

let cache = {};//缓存容器，直接把接口数据的缓存从localStorage中提升到内存中来
let cacheFilter = {};//用于处理第一次进页面，接口请求两次的问题
let apiLock = {}; //api锁，用于处理用户连续点击，导致连续发请求的情况

const rules = [
  {
    //不走缓存
    // 开发环境统一不走缓存,   默认不走缓存，  只有api请求第三个参数为true的时候，才开启缓存
    match: ({startCache}) => {
      const bool = !(typeof startCache === "boolean" && startCache);
      return bool;
    },
    action: ({args, cb}) => {
      // np.start()
      // console.log("不走缓存");
      return cb(...args).then(res => {
        // np.done();
        return res;
      });
    }
  },
  {
    //走缓存
    match: ({key, save, startCache}) => {
      const bool = cache[key];
      //想走缓存，但是没有缓存，所以这里第一次就会去服务端拿数据，并且要取消第二次数据请求。
      if (startCache && !save && !bool) {
        cacheFilter[key] = true;
      }
      // 有缓存，并且save为false
      return bool && !save;
    },
    action: ({args, cb, key, save}) => {
      return Promise.resolve(cache[key]);
    }
  },
  {
    //刷新缓存
    match: () => {
      return true;
    },
    action: ({args, cb, key}) => {
      if (cacheFilter[key] === true && cache[key]) {//说明第一发请求已经请求到后台，第二发请求应该被屏蔽
        cacheFilter[key] = false;
        return Promise.resolve(cache[key]);
      }
      return cb(...args).then(res => {
        cache[key] = res;
        localStorage.setItem(key, JSON.stringify(cache[key]));
        return res;
      });
    }
  }
];

function filter(path, cb, ...args) {
  // api请求的最后一个参数，如果是含有proxy的对象，则证明要搞缓存的事情
  let cacheObj = args[args.length - 1] ;
  let proxyData = (cacheObj && cacheObj.proxy);

  // 移除无用的proxy参数在请求上
  if(proxyData){
    args.pop();
  }else{
    proxyData = {};
  }

  // 根据请求路径生成一个唯一的key，用作缓存的唯一标识
  let key = initKey(args, path);

  const object = {
    args,
    cb,
    key,
    startCache: proxyData.cache,
    save: proxyData.save,
    path
  };

  //检查有无缓存
  if (!cache[key]) {
    try {
      cache[key] = JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error(error);
    }
  }

  !proxyData.save && np.start();

  //尝试这里处理重复请求的情况，但是之前有过一次bug，
  if (parseInt(apiLock[key], 10) !== 2) {
    //防止同时多次请求接口 //取消全局锁
    apiLock[key] = 0;
    for (let item of rules) {
      //职责链匹配
      if (item.match(object)) {
        return item
          .action(object)
          .then(res => {
            np.done();
            apiLock[key] = 0;
            return res;
          })
          .catch(e => {
            np.done();
            apiLock[key] = 0;
            console.log(`接口请求异常,路径为：${path}，用户token：${getCookie('token')}`);
            // return Promise.resolve({data: {}});
          });
      }
    }
  } else {
    return Promise.reject(`请勿多次提交`);
  }
}

// 根据请求路径生成一个唯一的key，用作缓存的唯一标识
function initKey(args, path) {
  let data = JSON.stringify(args);
  return (
    path +
    data
      .split()
      .sort()
      .join()
  );
}

//es6 代理方案
export let proxyConfig = {
  get: function (target, key, receiver) {
    return filter.bind(window, key, Reflect.get(target, key, receiver));
  }
};
//函数劫持，备选
export function proxy_(api) {
  Object.keys(api).forEach(key => {
    let cb = api[key].bind(api);
    api[key] = filter.bind(window, key, cb);
  });
  return api;
}



// WEBPACK FOOTER //
// ./src/proxy.js